/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const searchForm = document.querySelector(".search-bar");
if(searchForm) {
  searchForm.addEventListener("click", function(e) {
    const target = e.target;
    if(target.closest(".search-bar__input")) {
      !searchForm.classList.contains("is-expanded") && searchForm.classList.add("is-expanded");
    }
    if(target.closest(".new-results__items li")) {
      const searchText = target.closest(".new-results__items li").innerText.toLowerCase();
      window.location.assign('/search?q=' + searchText);
    }
  });
}

// Cached cart functions
const getCart = () => fetch(window.Shopify.routes.root + "cart.js").then(response => response.json());

function addItemToCart(id, qty, cback) {
  fetch("/cart/add.js", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      items: [{ id, quantity: qty }]
    }),
  })
  .then(response => {
    cback();
    return response.json();
  })
  .catch(error => {
    console.error("Error:", error);
  });
}

function updateItemInCart(id, qty, cback) {
  fetch("/cart/update.js", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      updates: { [id]: qty }
    }),
  })
  .then(response => {
    cback();
    return response.json();
  })
  .catch(error => {
    console.error("Error:", error);
  });
}

document.addEventListener("DOMContentLoaded", function() {
  // Optimize upsell price calculation
  function handleUpsellPrices(priceWrapEl, upsellItems) {
    if (!priceWrapEl || !upsellItems) return;
    
    const rawPrice = Number(priceWrapEl.dataset.rawPrice);
    const priceEl = priceWrapEl.querySelector(".price");
    const priceCompareEl = priceWrapEl.querySelector(".price.price--compare");
    
    let newPrice = rawPrice;
    
    upsellItems.forEach(function(el) {
      if (el.checked) {
        newPrice += Number(el.dataset.price);
      }
    });
    
    if (priceEl) {
      priceEl.innerHTML = (newPrice / 100).toFixed(2).toString().replace(".", ",");
    }

    if (priceCompareEl) {
      let rawComparePrice = Number(priceWrapEl.dataset.rawComparePrice);
      let newComparePrice = rawComparePrice;
      
      upsellItems.forEach(function(el) {
        if (el.checked) {
          newComparePrice += Number(el.dataset.comparePrice);
        }
      });
      
      priceCompareEl.innerHTML = (newComparePrice / 100).toFixed(2).toString().replace(".", ",");
    }
  }

  // On product page
  if (document.body.classList.contains("template-product")) {
    // Cache DOM elements
    const upsellSection = document.querySelectorAll('[name="upsell-product"]');
    const prodUpsellForm = document.querySelectorAll(".prodUpsellForm");
    const atcAddDynamicEl = document.querySelectorAll(".atcAddDynamicEl");
    const priceWrapper = document.querySelector(".priceWrapper");

    // Extract data helper function
    function extractData(elems) {
      let price = 0;
      const items = [];
      
      elems.forEach(function(el) {
        if (el.checked) {
          items.push({
            id: Number(el.dataset.relId),
            quantity: 1
          });
          price += Number(el.dataset.price);
        }
      });
      
      return { price, items };
    }

    // Setup upsell checkbox events
    upsellSection.forEach(function(el) {
      const id = el.dataset.relId;
      const parent = el.closest(".prodUpsell");
      const totPrcEl = parent?.querySelector(".prodUpsellTotal");
      const relatedThumb = parent?.querySelector(`.prodUpsellCell[data-id="${id}"]`);
      
      el.addEventListener("change", function() {
        const totPrice = extractData(upsellSection).price / 100;
        
        if (relatedThumb) {
          el.checked ? relatedThumb.classList.remove("d-none") : relatedThumb.classList.add("d-none");
        }
        
        if (totPrcEl) {
          totPrcEl.innerHTML = totPrice.toString().replace(".", ",");
        }
      });
    });

    // Setup upsell form submissions
    prodUpsellForm.forEach(function(el) {
      el.addEventListener("submit", function(e) {
        const redirect = el.dataset.redirect;
        const checkboxes = el.querySelectorAll('[name="upsell-product"]');
        const items = extractData(checkboxes).items;
        
        if (items && items.length) {
          e.preventDefault();
          
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items })
          })
          .then(response => {
            response.json();
            window.location.href = redirect;
          })
          .catch(error => console.error("Error:", error));
        }
      });
    });

    // Setup upsell checkboxes
    const upsellCheckbox = document.querySelectorAll(".upsellCheckbox");
    if (upsellCheckbox && upsellCheckbox.length) {
      upsellCheckbox.forEach(function(el) {
        const wrapper = el.closest(".upsellCheckboxesWrapper");
        const parent = el.closest(".upsellCheckboxes");
        const itemAndSiblings = parent?.querySelectorAll(".upsellCheckbox");
        const parentsSiblings = wrapper ? wrapper.querySelectorAll(".upsellCheckboxes") : [];
        
        el.addEventListener("change", () => {
          const varID = el.dataset.relId;
          
          if (parentsSiblings.length > 1) {
            const syncedItems = wrapper.querySelectorAll(`.upsellCheckboxes.d-none .upsellCheckbox[data-rel-id="${varID}"]`);
            
            syncedItems.forEach(item => {
              item.checked = el.checked;
            });
          }

          handleUpsellPrices(priceWrapper, itemAndSiblings);
        });
      });
    }

    // Handle product form submissions
    const productForm = document.querySelectorAll(".productForm");
    if (productForm && productForm.length) {
      productForm.forEach(function(el) {
        const submitBtn = el.querySelector(".productATC");
        
        if (submitBtn) {
          submitBtn.addEventListener("click", (e) => {
            const currentVariantID = window.SELECTED_VARIANT_ID;
            const upsellCheckbox = el.querySelectorAll(`.upsellCheckbox[data-sel-id="${currentVariantID}"]:checked`);
            const items = extractData(upsellCheckbox).items;
            
            if (upsellCheckbox && items && items.length) {
              e.preventDefault();
              
              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items })
              })
              .then(() => el.submit())
              .catch(error => console.error("Error:", error));
            }
          });
        }
      });
    }

    // Handle variant changes
    document.addEventListener("variant:changed", function(event) {
      const variant = event.detail.variant;
      
      if (priceWrapper) {
        priceWrapper.dataset.rawPrice = variant.price;
        window.SELECTED_VARIANT_ID = variant.id;
      }

      // Update delivery time messages
      const variantDeliveryItems = document.querySelectorAll(".variantDelivery");
      const variantDeliveryItem = document.querySelectorAll(`.variantDelivery[data-variant-id="${variant.id}"]`);
      
      if (variantDeliveryItems && variantDeliveryItems.length) {
        variantDeliveryItems.forEach(el => el.classList.add("d-none"));
      }
      
      if (variantDeliveryItem && variantDeliveryItem.length) {
        variantDeliveryItem.forEach(el => el.classList.remove("d-none"));
      }

      // Update upsell checkboxes
      const upsellCheckboxes = document.querySelectorAll(".upsellCheckboxes");
      const activeUpsellCheckbox = document.querySelector(`.upsellCheckboxes[data-id="${variant.id}"]`);
      
      if (upsellCheckboxes && upsellCheckboxes.length) {
        upsellCheckboxes.forEach(el => {
          el.classList.add("d-none", "is-active");
        });
      }
      
      if (activeUpsellCheckbox) {
        activeUpsellCheckbox.classList.remove("d-none", "is-active");
        handleUpsellPrices(priceWrapper, activeUpsellCheckbox.querySelectorAll(".upsellCheckbox"));
      }
    });

    // Cart update handlers
    atcAddDynamicEl.forEach(function(el) {
      const btnAdd = el.querySelector(".atcDynamicBtnAdd");
      const btnRmv = el.querySelector(".atcAddDynamicBtnRmv");
      
      // Cart state change handlers
      function onCartChanged() {
        getCart().then(data => {
          const cartItemsCount = document.querySelectorAll(".header__cart-count");
          cartItemsCount?.forEach(cntr => {
            cntr.innerHTML = data.item_count;
          });
        });
      }
      
      function onAddedToCart() {
        el.classList.add("added");
        onCartChanged();
      }
      
      function onRemovedFromCart() {
        el.classList.remove("added");
        onCartChanged();
      }
      
      // Setup click handlers
      if (btnAdd) {
        btnAdd.addEventListener("click", function() {
          const varId = btnAdd.dataset.variantId;
          const varQty = btnAdd.dataset.quantity;
          addItemToCart(varId, varQty, onAddedToCart);
        });
      }
      
      if (btnRmv) {
        btnRmv.addEventListener("click", function() {
          const varId = btnAdd.dataset.variantId;
          updateItemInCart(varId, 0, onRemovedFromCart);
        });
      }
    });
  }
  
  // Handle empty blocks
  const hideBlockIfEmpty = document.querySelectorAll(".hideBlockIfEmpty");
  if (hideBlockIfEmpty && hideBlockIfEmpty.length) {
    hideBlockIfEmpty.forEach(function(el) {
      const content = el.querySelector(".hideBlockIfEmptyContent");
      if (content && content.innerHTML.trim() === "") {
        el.classList.add("d-none");
      }
    });
  }
  
  // Handle review scores
  const reviewScore = document.querySelectorAll(".reviewScore");
  if (reviewScore && reviewScore.length && typeof REVIEW_SCORE !== "undefined") {
    reviewScore.forEach(function(el) {
      el.innerHTML = REVIEW_SCORE;
    });
  }
  
  // Optimize product bulk discount handler
  const productBulk = document.querySelector(".product-bulkdiscount");
  
  if (productBulk) {
    const quantityInput = document.querySelector(".quantity-selector.quantity-selector--product input");
    const priceWrapper = document.querySelector(".product-form .priceWrapper");
    
    if (!(quantityInput && priceWrapper)) return;
    
    const regularPrice = +priceWrapper.dataset.rawPrice;
    const comparePrice = +priceWrapper.dataset.rawComparePrice;
    
    productBulk.addEventListener("click", function(e) {
      const currentBulk = e.target.closest(".product-bulkdiscount--cell");
      if (!currentBulk) return;
      
      const productBulkInput = currentBulk.querySelector('input');
      if (!productBulkInput) return;
      
      const productBulkInputValue = productBulkInput.value;
      quantityInput.value = productBulkInputValue;
      
      const isV2 = document.querySelector('body').classList.contains("v2");
      const bulkPriceElement = isV2 
        ? currentBulk.querySelector('.product-bulkdiscount--item-value')
        : currentBulk.querySelectorAll('.product-bulkdiscount--item-value span')[0];
      
      let currentBulkPrice = bulkPriceElement 
        ? parseInt(bulkPriceElement.innerText.replace(",", "")) * (isV2 ? productBulkInputValue : 1)
        : regularPrice;
      
      if (document.querySelector('body').classList.contains("template-v3")) {
        if (comparePrice && comparePrice != regularPrice) {
          const comparePriceWrapper = priceWrapper.querySelector(".price.price--compare");
          const regularPriceWrapper = priceWrapper.querySelector(".price.price--highlight");
          
          if (!(comparePriceWrapper && regularPriceWrapper)) return;
          
          const isSamePrice = currentBulkPrice === regularPrice;
          const formattedComparePriceValue = isSamePrice 
            ? (comparePrice / 100 * productBulkInputValue) 
            : (regularPrice / 100 * productBulkInputValue);
            
          comparePriceWrapper.innerHTML = `<span class="visually-hidden">Regular price</span>${formattedComparePriceValue.toFixed(2).toString().replace(".", ",")}`;
          regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100).toFixed(2).toString().replace(".", ",")}`;
          
          if ((regularPrice / 100 * productBulkInputValue) === (currentBulkPrice / 100)) {
            comparePriceWrapper.innerHTML = `<span class="visually-hidden">Regular price</span>${(comparePrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".", ",")}`;
          }
        } else {
          const regularPriceWrapper = priceWrapper.querySelector(".price");
          if (regularPriceWrapper) {
            regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100).toFixed(2).toString().replace(".", ",")}`;
          }
        }
      }
    });
  }

  // Optimize JudgeMe review form handling
  const judgemeButton = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link');
  if (judgemeButton) {
    judgemeButton.addEventListener("click", function() {
      const popupOpenLink = document.querySelector('.popup-open-link');
      if (!popupOpenLink) return;
      
      popupOpenLink.click();
      
      // Get JudgeMe form elements
      const judgemeForm = document.querySelector('#judgeme_product_reviews .jdgm-form');

      if (!judgemeForm) return;

      const judgemeFormName = judgemeForm.querySelector('input[name="reviewer_name"]');
      const judgemeFormEmail = judgemeForm.querySelector('input[name="reviewer_email"]');
      const judgemeFormScore = judgemeForm.querySelector('input[name="score"]');
      const judgemeFormTitle = judgemeForm.querySelector('input[name="review_title"]');
      const judgemeFormBody = judgemeForm.querySelector('textarea[name="review_body"]');
      const judgemeFormPhoto = judgemeForm.querySelector('input[name="pictures"]');
      const judgemeFormVideo = judgemeForm.querySelector('input[name="video"]');
      const judgemeFormSubmit = judgemeForm.querySelector('input[type="submit"]');
      
      // Get popup form elements
      const popupForm = document.querySelector('#review-form .review-form__body');

      if (!popupForm) return;
      
      const popupFormName = popupForm.querySelector('input[name="reviewer_name"]');
      const popupFormEmail = popupForm.querySelector('input[name="reviewer_email"]');
      const popupFormScore = popupForm.querySelector('.rating');
      const popupFormTitle = popupForm.querySelector('textarea[name="review_title"]');
      const popupFormBody = popupForm.querySelector('input[name="review_body"]');
      const popupFormPhoto = popupForm.querySelector('input[name="pictures"]');
      const popupFormVideo = popupForm.querySelector('input[name="video"]');
      const popupFormSubmit = popupForm.querySelector('.review-form__submit');
      
      // Set up photo upload handling
      if (popupFormPhoto) {
        const photoItems = popupForm.querySelector(".review-form__pictures");
        if (!photoItems) return;
        
        let files;
        
        popupFormPhoto.addEventListener("change", function() {
          files = this.files;
          if (files && files.length) showFile();
        });
        
        function showFile() {
          const dataTransfer = new DataTransfer();
          const validExtensions = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];
          
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileType = file.type;
            
            if (validExtensions.includes(fileType)) {
              const fileName = file.name;
              const fileReader = new FileReader();
              
              fileReader.onload = () => {
                const fileURL = fileReader.result;
                const imgItem = `
                  <div data-name="${fileName}" class="addphoto__item">
                    <div class="addphoto__image-ibg">
                      <img src="${fileURL}" alt="review" />
                    </div>
                    <div class="addphoto__body">
                      <div class="addphoto__close">
                        <svg focusable="false" viewBox="0 0 19 19" role="presentation">
                          <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
                        </svg>
                      </div>
                    </div>
                  </div>`;
                
                photoItems.insertAdjacentHTML("beforeend", imgItem);
              };
              
              fileReader.readAsDataURL(file);
              dataTransfer.items.add(file);
            } else {
              alert("This is not an Image File!");
            }
          }
          
          if (judgemeFormPhoto) {
            judgemeFormPhoto.files = dataTransfer.files;
          }
        }
        
        // Delete photo handler
        photoItems.addEventListener("click", function(e) {
          if (!e.target.closest(".addphoto__close")) return;
          
          const currentPhoto = e.target.closest(".addphoto__item");
          if (!currentPhoto) return;
          
          const photoName = currentPhoto.dataset.name;
          currentPhoto.remove();
          
          if (judgemeFormPhoto && judgemeFormPhoto.files) {
            const dt = new DataTransfer();
            
            for (let i = 0; i < judgemeFormPhoto.files.length; i++) {
              const file = judgemeFormPhoto.files[i];
              if (file.name !== photoName) {
                dt.items.add(file);
              }
            }
            
            judgemeFormPhoto.files = dt.files;
            if (popupFormPhoto) popupFormPhoto.files = dt.files;
          }
        });
      }
      
      // Set up video upload handling
      if (popupFormVideo) {
        const videoItems = popupForm.querySelector(".review-form__video");
        if (!videoItems) return;
        
        let files;
        
        popupFormVideo.addEventListener("change", function() {
          files = this.files;
          if (files && files.length) showFile();
        });
        
        function showFile() {
          const dataTransfer = new DataTransfer();
          
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileName = file.name;
            const fileReader = new FileReader();
            
            fileReader.onload = () => {
              const fileURL = fileReader.result;
              const videoInputLabel = videoItems.querySelector('.review-form__row--media-video');
              
              const videoItem = `
                <div data-name="${fileName}" class="addphoto__item">
                  <svg class="addphoto__item-video-bg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                    <g>
                      <path style="fill:#010002;" d="M24,14.059V5.584L18.414,0H0v32h24v-0.059c4.499-0.5,7.998-4.31,8-8.941 C31.998,18.366,28.499,14.557,24,14.059z M17.998,2.413L21.586,6h-3.588C17.998,6,17.998,2.413,17.998,2.413z M2,30V1.998h14v6.001 h6v6.06c-0.693,0.076-1.361,0.238-2,0.464V12H8v3l-4-3v10l4-3v3h6.059C14.022,22.329,14,22.661,14,23c0,2.829,1.308,5.352,3.35,7H2 z M23,29.883c-3.801-0.009-6.876-3.084-6.885-6.883c0.009-3.801,3.084-6.876,6.885-6.885c3.799,0.009,6.874,3.084,6.883,6.885 C29.874,26.799,26.799,29.874,23,29.883z"/>
                      <path style="fill:#010002;" d="M19,27h3l-3-3V27z M19.999,23l5-5L28,21l-5,5L19.999,23z"/>
                    </g>
                  </svg>
                  <div class="addphoto__image-ibg">
                    <video src="${fileURL}"></video>
                  </div>
                  <div class="addphoto__body">
                    <div class="addphoto__close">
                      <svg focusable="false" viewBox="0 0 19 19" role="presentation">
                        <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
                      </svg>
                    </div>
                  </div>
                </div>`;
              
              videoItems.insertAdjacentHTML("beforeend", videoItem);
              
              if (videoInputLabel) videoInputLabel.style.display = "none";
            };
            
            fileReader.readAsDataURL(file);
            dataTransfer.items.add(file);
          }
          
          if (judgemeFormVideo) {
            judgemeFormVideo.files = dataTransfer.files;
          }
        }
        
        // Delete video handler
        videoItems.addEventListener("click", function(e) {
          if (!e.target.closest(".addphoto__close")) return;
          
          const currentVideo = e.target.closest(".addphoto__item");
          if (!currentVideo) return;
          
          currentVideo.remove();
          
          const videoInputLabel = videoItems.querySelector('.review-form__row--media-video');
          if (videoInputLabel) videoInputLabel.style.display = "inline-block";
          
          if (judgemeFormVideo && judgemeFormVideo.files) {
            const dt = new DataTransfer();
            const photoName = currentVideo.dataset.name;
            
            for (let i = 0; i < judgemeFormVideo.files.length; i++) {
              const file = judgemeFormVideo.files[i];
              if (file.name !== photoName) {
                dt.items.add(file);
              }
            }
            
            judgemeFormVideo.files = dt.files;
            if (popupFormVideo) popupFormVideo.files = dt.files;
          }
        });
      }
      
      // Handle form submission
      if (popupFormSubmit) {
    
        popupFormSubmit.addEventListener("click", function() {
          const error = formValidate.getErrors(popupForm);
          
          if (error === 0 && popupFormScore && popupFormScore.getAttribute("title")) {
            // Transfer data to JudgeMe form
            if (judgemeFormName && popupFormName) judgemeFormName.value = popupFormName.value;
            if (judgemeFormEmail && popupFormEmail) judgemeFormEmail.value = popupFormEmail.value;
            if (judgemeFormScore && popupFormScore) judgemeFormScore.value = popupFormScore.getAttribute("title");
            if (judgemeFormTitle && popupFormTitle) judgemeFormTitle.value = popupFormTitle.value;
            if (judgemeFormBody && popupFormBody) judgemeFormBody.value = popupFormBody.value;
            
            // Submit the form
            if (judgemeFormSubmit) {
              setTimeout(() => judgemeFormSubmit.click(), 50);
              setTimeout(() => judgemeFormSubmit.click(), 50);
            }
          }
        });
      }
    });
  }
  
  // Optimized form fields initialization
  formFieldsInit({
    viewPass: false,
    autoHeight: false
  });
});

// Optimize scroll handlers
const atcBottomEdge = document.querySelectorAll(".atcBottomEdge");

function handleDocumentScrolledClass() {
  const scrolled = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
  document.documentElement.classList[scrolled > 0 ? 'add' : 'remove']('is-scrolled');
}

function isElemScrolledOutOfView(elements) {
  elements.forEach((element) => {
    if (!element) return;
    
    const rect = element.getBoundingClientRect();
    const scrollTop = document.body.scrollTop;
    const elementTop = rect.top + scrollTop;
    const header = document.querySelector("#shopify-section-header");
    const paymentContainer = document.querySelector(".product-form__payment-container");
    
    if (!paymentContainer) return;
    
    const headerHeight = header ? header.offsetHeight : 0;
    const isScrolledOut = scrollTop > elementTop || (elementTop - window.innerHeight - paymentContainer.offsetHeight) > 0;
    
    document.body.classList[isScrolledOut ? 'add' : 'remove']('is-atc-sticky');
    
    if (window.innerWidth > 1000) {
      paymentContainer.style.top = isScrolledOut ? `${headerHeight}px` : '0';
    }
  });
}

function announcementBarHeight() {
  const target = document.querySelector(".announcement-bar");
  if (!target) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const header = document.querySelector("#shopify-section-header");
        const headerHeight = header ? header.offsetHeight : 0;
        const newTop = headerHeight + target.offsetHeight;
        const paymentContainer = document.querySelector(".product-form__payment-container");
        
        if (paymentContainer) {
          paymentContainer.style.top = `${newTop}px`;
        }
      }
    });
  }, { threshold: 1 });
  
  observer.observe(target);
}

// Setup scroll handlers if needed
if (atcBottomEdge && atcBottomEdge.length) {
  const handleScroll = () => {
    isElemScrolledOutOfView(atcBottomEdge);
    announcementBarHeight();
  };
  
  isElemScrolledOutOfView(atcBottomEdge);
  announcementBarHeight();
  
  // Use passive event listener for better performance
  window.addEventListener("scroll", handleScroll, { passive: true });
}

// Handle document scroll state
handleDocumentScrolledClass();
window.addEventListener("scroll", handleDocumentScrolledClass, { passive: true });

// Cached slider variables
let sliderTag = null;
let sliderProduct = null;
let sliderIcons = null;
let sliderOffers = null;
const mediaQuerySizeLarge = 1000;
const mediaQuerySize = 640;

// Optimize slider initialization functions
function sliderTagInit() {
  if (!document.querySelector(".swiper.tag-swiper") || sliderTag) return;
  
  sliderTag = new Swiper(".swiper.tag-swiper", {
    slidesPerView: "auto",
    spaceBetween: 11,
    scrollbar: {
      el: ".swiper.tag-swiper .swiper-scrollbar",
      draggable: true,
      snapOnRelease: true,
    }
  });
}

function sliderTagDestroy() {
  if (!sliderTag) return;
  sliderTag.destroy();
  sliderTag = null;
}

function sliderProductInit() {
  if (!document.querySelector(".blog-sidebar-swiper") || sliderProduct) return;
  
  sliderProduct = new Swiper(".blog-sidebar-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    scrollbar: {
      el: ".blog-sidebar-swiper .swiper-scrollbar",
      draggable: true,
    }
  });
}

function sliderProductDestroy() {
  if (!sliderProduct) return;
  sliderProduct.destroy();
  sliderProduct = null;
}

function sliderIconsInit() {
  if (!document.querySelector(".swiper-text-icons") || sliderIcons) return;
  
  sliderIcons = new Swiper(".swiper-text-icons", {
    slidesPerView: 1,
    spaceBetween: 20,
    scrollbar: {
      el: ".swiper-text-icons .swiper-scrollbar",
      draggable: true,
    }
  });
}

function sliderIconsDestroy() {
  if (!sliderIcons) return;
  sliderIcons.destroy();
  sliderIcons = null;
}

function sliderOffersDestroy() {
  if (!sliderOffers) return;
  sliderOffers.destroy();
  sliderOffers = null;
}

function sliderOffersInit() {
  if (!document.querySelector(".swiper.swiper-offers") || sliderOffers) return;
  
  sliderOffers = new Swiper(".swiper.swiper-offers", {
    slidesPerView: "auto",
    spaceBetween: 32,
    scrollbar: {
      el: ".swiper.swiper-offers .swiper-scrollbar",
      draggable: true,
      snapOnRelease: true,
    }
  });
}

// Optimized slider initialization with common configuration
function initSliders() {
  // Common Swiper config creator to reduce repetition
  function createSwiperConfig(options = {}) {
    return {
      observer: true,
      observeParents: true,
      speed: 800,
      ...options
    };
  }
  
  // Upsells slider
  if (document.querySelector(".swiper-upsells")) {
    new Swiper(".swiper-upsells", createSwiperConfig({
      slidesPerView: 3,
      spaceBetween: 16,
      navigation: {
        prevEl: ".pdp-upsells__swiper-buttons .swiper-button-prev",
        nextEl: ".pdp-upsells__swiper-buttons .swiper-button-next",
      },
      breakpoints: {
        320: { slidesPerView: 1.15, spaceBetween: 10 },
        467: { slidesPerView: 1.8, spaceBetween: 16 },
        640: { slidesPerView: 3, spaceBetween: 16 },
      }
    }));
  }
  
  // Products list slider
  if (document.querySelector(".swiper-products-list")) {
    new Swiper(".swiper-products-list", createSwiperConfig({
      slidesPerView: 3,
      spaceBetween: 16,
      scrollbar: {
        el: ".swiper-products-list .swiper-scrollbar",
        draggable: true,
      },
      navigation: {
        prevEl: ".swiper-products-list .swiper-button-prev",
        nextEl: ".swiper-products-list .swiper-button-next",
      },
      breakpoints: {
        320: { slidesPerView: 1.15, spaceBetween: 10 },
        467: { slidesPerView: 1.8, spaceBetween: 16 },
        640: { slidesPerView: 2.8, spaceBetween: 17.5 },
        991: { slidesPerView: 3.3, spaceBetween: 17.5 },
        1200: { slidesPerView: 5, spaceBetween: 17.5 },
      }
    }));
  }
  
  // Cart products slider
  if (document.querySelector(".cart-wrapper .swiper-products-list")) {
    new Swiper(".cart-wrapper .swiper-products-list", createSwiperConfig({
      slidesPerView: 3,
      spaceBetween: 16,
      navigation: {
        prevEl: ".swiper-products-list .swiper-button-prev",
        nextEl: ".swiper-products-list .swiper-button-next",
      },
      breakpoints: {
        320: { slidesPerView: 1.15, spaceBetween: 10 },
        467: { slidesPerView: 1.8, spaceBetween: 16 },
        640: { slidesPerView: 2.8, spaceBetween: 17.5 },
        999: { slidesPerView: 2.2, spaceBetween: 17.5 },
        1200: { slidesPerView: 4, spaceBetween: 17.5 },
      }
    }));
  }
  
  // Blog post products slider
  if (document.querySelector(".section__blog-post .swiper-products-list")) {
    new Swiper(".section__blog-post .swiper-products-list", createSwiperConfig({
      slidesPerView: 3,
      spaceBetween: 16,
      navigation: {
        prevEl: ".section__blog-post .swiper-products-list .swiper-button-prev",
        nextEl: ".section__blog-post .swiper-products-list .swiper-button-next",
      },
      breakpoints: {
        320: { slidesPerView: 1.15, spaceBetween: 10 },
        467: { slidesPerView: 1.8, spaceBetween: 16 },
        640: { slidesPerView: 2.8, spaceBetween: 17.5 },
        991: { slidesPerView: 2.8, spaceBetween: 17.5 }
      }
    }));
  }
  
  // Image with text slider
  if (document.querySelector(".image-with-text__slider-target.swiper")) {
    new Swiper(".image-with-text__slider-target.swiper", createSwiperConfig({
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: true,
      pagination: {
        el: '.slider-dots',
        clickable: true,
      },
      navigation: {
        prevEl: ".image-with-text__slider .slider-arrow.prev",
        nextEl: ".image-with-text__slider .slider-arrow.next",
      }
    }));
  }
}

// Use requestIdleCallback or setTimeout for non-critical initialization
function initOnLoad() {
  document.body.classList.add('loaded');
  const windowWidth = window.innerWidth;
  
  if (windowWidth <= mediaQuerySize) {
    sliderTagInit();
    sliderProductInit();
    sliderIconsInit();
  }
  
  if (windowWidth <= mediaQuerySizeLarge) {
    sliderOffersInit();
  }
  
  // Initialize sliders after DOM is fully loaded and parsed
  initSliders();
}

// Event listeners for initialization
if (window.requestIdleCallback) {
  window.addEventListener("load", () => requestIdleCallback(initOnLoad));
} else {
  window.addEventListener("load", initOnLoad);
}

// Debounced resize handler
let resizeTimer;
window.addEventListener("resize", function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    const windowWidth = window.innerWidth;
    
    windowWidth <= mediaQuerySize ? sliderTagInit() : sliderTagDestroy();
    windowWidth <= mediaQuerySize ? sliderProductInit() : sliderProductDestroy();
    windowWidth <= mediaQuerySize ? sliderIconsInit() : sliderIconsDestroy();
    windowWidth <= mediaQuerySizeLarge ? sliderOffersInit() : sliderOffersDestroy();
  }, 250);
});

// Optimized form fields initialization
function formFieldsInit(options = { viewPass: false, autoHeight: false }) {
  // Use event delegation for better performance
  document.body.addEventListener("focusin", function(e) {
    const targetElement = e.target;
    
    if (targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA') {
      if (!targetElement.hasAttribute('data-no-focus-classes')) {
        targetElement.classList.add('_form-focus');
        targetElement.parentElement?.classList.add('_form-focus');
      }
      
      if (targetElement.hasAttribute('data-validate')) {
        formValidate.removeError(targetElement);
      }
    }
  });
  
  document.body.addEventListener("focusout", function(e) {
    const targetElement = e.target;
    
    if (targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA') {
      if (!targetElement.hasAttribute('data-no-focus-classes')) {
        targetElement.classList.remove('_form-focus');
        targetElement.parentElement?.classList.remove('_form-focus');
      }
      
      // Instant validation
      if (targetElement.hasAttribute('data-validate')) {
        formValidate.validateInput(targetElement);
      }
    }
  });
  
  // Password view toggle
  if (options.viewPass) {
    document.addEventListener("click", function(e) {
      const targetElement = e.target;
      
      if (targetElement.closest('[class*="__viewpass"]')) {
        const inputType = targetElement.classList.contains('_viewpass-active') ? "password" : "text";
        const passwordInput = targetElement.parentElement?.querySelector('input');
        
        if (passwordInput) {
          passwordInput.setAttribute("type", inputType);
          targetElement.classList.toggle('_viewpass-active');
        }
      }
    });
  }
  
  // Auto-height for textareas
  if (options.autoHeight) {
    const textareas = document.querySelectorAll('textarea[data-autoheight]');
    
    if (textareas.length) {
      textareas.forEach(textarea => {
        const startHeight = textarea.hasAttribute('data-autoheight-min') 
          ? Number(textarea.dataset.autoheightMin) 
          : Number(textarea.offsetHeight);
          
        const maxHeight = textarea.hasAttribute('data-autoheight-max') 
          ? Number(textarea.dataset.autoheightMax) 
          : Infinity;
          
        setHeight(textarea, Math.min(startHeight, maxHeight));
        
        textarea.addEventListener('input', () => {
          if (textarea.scrollHeight > startHeight) {
            textarea.style.height = 'auto';
            setHeight(textarea, Math.min(Math.max(textarea.scrollHeight, startHeight), maxHeight));
          }
        });
      });
    }
  }
  
  function setHeight(textarea, height) {
    textarea.style.height = `${height}px`;
  }
}

// Optimized form validation
const formValidate = {
  getErrors(form) {
    if (!form) return 0;
    
    let error = 0;
    const formRequiredItems = form.querySelectorAll('*[data-required]');
    
    if (formRequiredItems.length) {
      formRequiredItems.forEach(formRequiredItem => {
        if (!formRequiredItem.disabled) {
          error += this.validateInput(formRequiredItem);
        }
      });
    }
    
    return error;
  },
  
  validateInput(formRequiredItem) {
    if (!formRequiredItem) return 0;
    
    let error = 0;
    
    if (formRequiredItem.dataset.required === "email") {
      formRequiredItem.value = formRequiredItem.value.replace(" ", "");
      
      if (this.emailTest(formRequiredItem)) {
        this.addError(formRequiredItem);
        error++;
      } else {
        this.removeError(formRequiredItem);
      }
    } else if (formRequiredItem.type === "checkbox" && !formRequiredItem.checked) {
      this.addError(formRequiredItem);
      error++;
    } else {
      if (!formRequiredItem.value.trim()) {
        this.addError(formRequiredItem);
        error++;
      } else {
        this.removeError(formRequiredItem);
      }
    }
    
    return error;
  },
  
  addError(formRequiredItem) {
    if (!formRequiredItem) return;
    
    formRequiredItem.classList.add('_form-error');
    formRequiredItem.parentElement?.classList.add('_form-error');
    
    const inputError = formRequiredItem.parentElement?.querySelector('.form__error');
    if (inputError) formRequiredItem.parentElement?.removeChild(inputError);
    
    if (formRequiredItem.dataset.error) {
      formRequiredItem.parentElement?.insertAdjacentHTML('beforeend', `<div class="form__error">${formRequiredItem.dataset.error}</div>`);
    }
    
    const tabBody = formRequiredItem.closest(".tabs__body");
    if (tabBody) {
      const tabBodyIndex = tabBody.dataset.index;
      const currentForm = formRequiredItem.closest("form");
      
      if (currentForm) {
        const tabNavigation = currentForm.querySelector(`.tabs__title[data-index="${tabBodyIndex}"]`);
        
        if (tabNavigation && !tabNavigation.classList.contains("title-error") && !tabNavigation.classList.contains("_tab-active")) {
          tabNavigation.classList.add("title-error");
          
          setTimeout(() => {
            if (tabNavigation.classList.contains("title-error")) {
              tabNavigation.classList.remove("title-error");
            }
          }, 3000);
        }
      }
    }
  },
  
  removeError(formRequiredItem) {
    if (!formRequiredItem) return;
    
    formRequiredItem.classList.remove('_form-error');
    formRequiredItem.parentElement?.classList.remove('_form-error');
    
    const errorElement = formRequiredItem.parentElement?.querySelector('.form__error');
    if (errorElement) {
      formRequiredItem.parentElement?.removeChild(errorElement);
    }
  },
  
  formClean(form) {
    if (!form) return;
    
    form.reset();
    
    setTimeout(() => {
      const inputs = form.querySelectorAll('input,textarea');
      inputs.forEach(el => {
        el.parentElement?.classList.remove('_form-focus');
        el.classList.remove('_form-focus');
        this.removeError(el);
      });
      
      const checkboxes = form.querySelectorAll('.checkbox__input');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
    }, 0);
  },
  
  emailTest(formRequiredItem) {
    return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(formRequiredItem.value);
  }
};